'use client';

import { useState } from 'react';

import { useTrackEventAmplitude } from '../../../../../../core/Tracking/Amplitude/Amplitude';
import { NaturalScrollCarousel } from '../../../../../../design-system/components/natural-scroll-carousel/NaturalScrollCarousel';
import { HomePageDocument } from '../../../../../../resources/homePageDocument/domain/types/homePageDocument';
import { InfluencerUgcCard } from '../Card/InfluencerUgcCard';
import { EvaneosSocialMediaCard } from '../EvaneosSocialMediaCard/EvaneosSocialMediaCard';
import { InfluencerUgcVideoModal } from '../VideoModal/InfluencerUgcVideoModal';

type InfluencersUgcCarouselProps = {
    influencersUgc: HomePageDocument['influencersUgc'];
};

export function InfluencersUgcCarousel({ influencersUgc }: InfluencersUgcCarouselProps) {
    const { trackEvent } = useTrackEventAmplitude();

    const [selectedInfluencerWithVideo, setSelectedInfluencerWithVideo] = useState<Pick<
        InfluencersUgcCarouselProps['influencersUgc'][number],
        'video'
    > | null>(null);

    const isModalOpen = selectedInfluencerWithVideo !== null;

    function handleVideoClick({
        video,
    }: {
        video: InfluencersUgcCarouselProps['influencersUgc'][number]['video'];
    }) {
        setSelectedInfluencerWithVideo({ video });

        trackEvent((ampli, defaultProperties) => {
            ampli.videoPlayed({
                ...defaultProperties,
                block: 'social',
            });
        });
    }
    return (
        <>
            <NaturalScrollCarousel
                scrollSnapAlign="center"
                trackingInformation={{
                    navClick: {
                        block: 'social',
                    },
                }}
            >
                <NaturalScrollCarousel.Slide>
                    <EvaneosSocialMediaCard />
                </NaturalScrollCarousel.Slide>
                {influencersUgc.map((influencer, index) => (
                    <NaturalScrollCarousel.Slide key={index}>
                        <InfluencerUgcCard influencerUgc={influencer} onClick={handleVideoClick} />
                    </NaturalScrollCarousel.Slide>
                ))}
            </NaturalScrollCarousel>

            {isModalOpen ? (
                <InfluencerUgcVideoModal
                    isOpen={isModalOpen}
                    close={() => setSelectedInfluencerWithVideo(null)}
                    video={selectedInfluencerWithVideo.video}
                />
            ) : null}
        </>
    );
}
